export default {
    isPhone(value) {
        const re = /8\(9\d{2}\)\d{3}-\d{2}-\d{2}/;
        return re.test(value);
    },
    isAnyPhone(value) {
        const phone = value.replace(/[^+0-9]/g, '');
        return phone.length >= 12;
    },
    isEmail(value) {
        // eslint-disable-next-line
        const r = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
        return r.test(value);
    },
    isFloat(value) {
        const r = /^[0-9]+[.,][0-9]+/i;
        return r.test(value);
    },
    isPhoneCity(value) {
        const re = /\+7\(9\d{2}\)\d{3}-\d{2}-\d{2}/;
        return re.test(value);
    },
};
